import React, { PureComponent } from 'react'
import { Modal } from 'hljd'
import Carousel from '../Carousel'
import { getObjValue, addSuffix } from '@hlj/hlj-utils'
import style from './style.module.less'

export default class extends PureComponent {
  static defaultProps = {
    imgList: [],
    slideWidth: 530,
    slideHeight: 320,
    initialSlide: 0,
    keyField: 'url',
    autoSuffix: true,
    visible: false
  }
  setSuffix = (url, _suffix) => {
    if (url.includes('imageMogr2')) {
      return url + '|' + _suffix
    }
    return addSuffix(url, _suffix, false)
  }
  render() {
    const {
      imgList,
      slideWidth,
      slideHeight,
      keyField,
      suffix,
      initialSlide,
      visible,
      onCancel,
      autoSuffix
    } = this.props
    let _modalWidth = slideWidth + 200
    let list = typeof imgList === 'string' ? [imgList] : imgList
    let _suffix = `imageView2/2/w/${slideWidth}/h/${slideHeight}`
    if (suffix) {
      _suffix = suffix
    }
    return (
      <Modal
        width={_modalWidth}
        footer={null}
        visible={visible}
        onCancel={onCancel}
      >
        {list && list.length ? (
          <Carousel initialSlide={initialSlide} width={slideWidth}>
            {list.map((item, i) => {
              const url =
                typeof item === 'string' ? item : getObjValue(item, keyField)
              const _url = autoSuffix ? this.setSuffix(url, _suffix) : url
              return (
                <div key={i}>
                  <div
                    className={style.slide}
                    style={{
                      height: slideHeight
                    }}
                  >
                    <img src={_url} style={{ maxHeight: '100%' }} />
                  </div>
                </div>
              )
            })}
          </Carousel>
        ) : null}
      </Modal>
    )
  }
}
